/** Public, server-rendered article data. Never contains credentials or drafts. */
export function readBlogBootstrap(kind: 'article' | 'archive', identifier?: string) {
  if (typeof document === 'undefined') return undefined;
  try {
    const element = document.getElementById('etlyn-blog-bootstrap');
    if (!element?.textContent) return undefined;
    const value = JSON.parse(element.textContent);
    if (value.kind !== kind) return undefined;
    if (kind === 'archive') return Array.isArray(value.posts) ? value.posts : undefined;
    const post = value.post;
    return post?.published === true && [post.slug, post.id].includes(identifier) ? post : undefined;
  } catch {
    return undefined;
  }
}
